export const API_PATH_LOGS = '/auditAction';
export const API_PATH_EXPORT_LOGS = `${API_PATH_LOGS}/export`;

export interface AuditActionDTO {
  id: number;
  userId: string;
  userName: string;
  dateTimeEntry: string;
  serviceId: string;
  actionType: string;
  endPointUrl: string;
  status: string;
  fieldDetails: string;
  recordName: string;
  clientIPAddress: string;
}
